/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, {useCallback, useEffect, useState, useRef} from "react";
import { Container, Row, Button,Col } from "react-bootstrap";
import "./Contactus.css";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import axios from "axios";
import MediaQuery from "react-responsive";
import LeadFormModal from "./LeadFormModal";
 
export default function Contactus({ links,loanPurpKeyword,
    noteRate,
    formHeading,
    showLeadFormModal,
    onHide,
    offerTerm }) {
  const [showFormModal, setShowFormModal] = useState(false);
  const [loanPurposeKwd, setLoanPurposeKwd] = useState("");
  const [frmHeading, setFrmHeading] = useState("");
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();
  useEffect(() => {
    /**
     * @author Pratik Kajrolkar
     * @date 07/17/2023
     * The below function is used to fetch the swmc footer data which
     * is stored in master JSON in S3 bucket.
     * @returns JSON Object of the requested file
     */
    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []); 
  const handleButtonClick = () => {
    // Replace 'https://example.com' with the URL you want to open.
    window.open("https://www.swmc.com/ApplyNow/?lof=P590", "_blank");
  };
  const handleApplyNowModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("");
    setFrmHeading("Apply Now");
  };
  const [node, setNode] = useState(null);
  const formRef = useCallback((node) => {
          // node refers to the name input field in the BorrowerLeadGenerationTool
       setNode(node);
       }, []);
  const handleCloseFormModal = () => setShowFormModal(false);
  return (
    <>
     <Container>
      <Row>
        <p className="comprehensivetext">These comprehensive insights into each loan program highlight their distinct features, making it easier for investors
         to choose the best option for their unique needs.</p>
         <hr className="hrline"/>
         <p className="yourjournytext">Your journey in the investment world demands expertise and trustworthiness. <br/>
          For questions or to begin your application, Rachael Santos is your go-to Loan Officer.</p>
      </Row>
      <Row className="mb-5">
        <Col className="applycol" sm={12} md={12} xl={6} xxl={6} lg={6}>
          <div className="applybtn text-center mb-3">
              <Button
                variant="primary"
                className="applyNowBtn"
                onClick={handleButtonClick}
              >
                Apply Now with Rachael
              </Button>
            </div>
            
          {/* <div>
            {showFormModal && (
              <LeadFormModal
                loanPurpKeyword={loanPurposeKwd}
                formHeading={frmHeading}
                showLeadFormModal={showFormModal}
                onHide={handleCloseFormModal}
              />
            )}
          </div> */}
      </Col>
      <Col sm={12} md={12} xl={1} xxl={1} lg={1}>
        <div className="vertical-line"></div>
      </Col>
      <Col sm={12} md={12} xl={5} xxl={5} lg={5}>
               <div className="Loinfo">
                  <h5>Rachael Santos</h5>
                  <p>NMLS 2029779 
                  <br/>Residential Mortgage Loan Originator
                  <br/>D: {" "}
                  <a href="tel:+12815008651">(281) 500-8651</a>
                  <br/> <a
                      href="mailto:rachael.santos@swmc.com"
                      className="linksu1"
                    > rachael.santos@swmc.com</a>
                  <br/><a
                      href="https://rs.sunwestmortgage.com/"
                      target="blank"
                      className="linksu"
                    >rs.sunwestmortgage.com</a>
                   {/* <a
                              style={{ color: "#fff" }}
                              target="_blank"
                              href={
                                footerInfoData.contactUs.address.googleMapsUrl
                              }
                              rel="noopener"
                            >
                              {footerInfoData.contactUs.address.fullAddress}
                            </a> */}
                             <a
                              style={{  }}
                              target="_blank"
                              href={
                                'https://www.google.com/maps/place/18303+Gridley+Rd,+Cerritos,+CA+90703,+USA/@33.8652706,-118.0940444,17z/data=!3m1!4b1!4m6!3m5!1s0x80dd2d737747d849:0xc43984d7f3429bee!8m2!3d33.8652706!4d-118.0914641!16s%2Fg%2F11b8z8nv15?entry=tts&shorturl=1'
                              }
                              rel="noopener"
                            >
                              <br/>18303 Gridley Rd.
                              <br/>Cerritos, CA 90703
                            </a></p>
               </div>
      </Col>
      {/* <hr className="hrline"/> */}
      </Row>
      <Row className="borrtoolrow mb-3">
        <Col sm={12} md={12} xl={1} xxl={1} lg={1}></Col>
        <Col className="borrleadtoolcol"sm={12} md={12} xl={10} xxl={10} lg={10}>
            <div className="request">
              <h5>Request a Callback from Rachael</h5>
            </div>
      <BorrowerLeadGenerationTool
          leadSource="Self"
          branch=""
          showModalBackBtn={false}
          // statesDomain={process.env.REACT_APP_STATE_DOMAIN}
          ref={formRef}
          loanOfficerUid="P590"
          mainBtnName="Call Me"
        />    
        
   
        </Col>
        <Col sm={12} md={12} xl={1} xxl={1} lg={1}></Col>
        </Row>
      </Container>
        <Container>
          <Row className="lastpara pb-3">
          
          <p>For all these programs, Sun West is acting as a broker.<br/>
        *25% and 20% down payment required for 75% and 80% LTV respectively.<br/>
        Being High Risk Loans, DSCR, Bridge, Fix and Flip and Commercial Construction Loans may include higher interest rates, closing costs, interest-only periods, or prepayment penalties.<br/>
        Interest-Only mortgages allow you to pay only the interest on the money you borrow for the first few years of the mortgage (the "interest-only period"). If you make interest-only payments, then at the end of the interest-only period you will still owe the original amount you borrowed and your monthly payment will increase because you must pay back the principal as well as interest. Your payments could increase even more if you have an Adjustable Rate Mortgage (ARM) and interest rate increase.<br/>
        DSCR stands for Debt-Service Coverage Ratio.<br/>
        On a Non-QM 30-year fixed rate purchase with loan amount $1,050,000  (at 75% LTV with 25% down from borrower and FICO 720), at an interest rate 10% with $0 discount points (Annual Percentage Rate: 10.031%), you will be required to make 360 equal monthly payments of $9,214.50 (which includes principal and interest only, so your actual payment, including taxes, insurance, and other property charges, will be higher).<br/>
        On a Commercial property 1-year fixed rate purchase with loan amount $980,000 (at 70% LTV with 30% down from borrower and FICO 720), at an interest rate 10.75% with $0 discount points (Annual Percentage Rate: 12.973%), you will be required to make 360 equal monthly payments of $8,779.17 (which includes principal and interest only, so your actual payment, including taxes, insurance, and other property charges, will be higher).<br/>
        On a Fix and Flip 1-year fixed rate purchase with loan amount $280,000 (at 70% LTV with 30% down from borrower and FICO 720), at an interest rate 9.25% with $0 discount points (Annual Percentage Rate: 9.622%), you will be required to make 360 equal monthly payments of $2,158.33 (which includes principal and interest only, so your actual payment, including taxes, insurance, and other property charges, will be higher).<br/>
      </p>
          </Row>
        </Container>
    
    </>
  );
}
